import { render } from "./MultiImage.vue?vue&type=template&id=c2872e22"
import script from "./MultiImage.vue?vue&type=script&lang=js"
export * from "./MultiImage.vue?vue&type=script&lang=js"

import "./MultiImage.vue?vue&type=style&index=0&id=c2872e22&lang=css"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__